module.exports = __webpack_public_path__ + "img/essex-sword-logo.9c1067e1.svg";